import React from "react";
import clsx from "clsx";

import { ConfigSort } from "@usereactify/search";

import { AccordionAnimation } from "~/components/Accordion/AccordionAnimation";

import { FormRadio, IconChevron } from "@bared/ui";

type FilterSectionSortProps = {
  onClose: () => void;
  show: boolean;
  sortOption?: ConfigSort;
  sortOptions: ConfigSort[];
  setSortOption: (handle: string) => void;
  scrollTo: (i: number, j: any, k: number) => void;
};
export const FilterSectionSort = ({
  sortOption,
  sortOptions,
  setSortOption,
  scrollTo,
  show,
  onClose,
}: FilterSectionSortProps) => {
  return (
    <div className={clsx(show && "border-b", "w-full overflow-hidden")}>
      <div
        className="transition-presentation flex w-full items-center justify-start border-b hover:text-secondary"
        onClick={onClose}
      >
        <button className="grow px-mini py-maxi text-left">
          Sort By: {sortOption?.name}
        </button>
        <IconChevron
          className={clsx(
            show && "rotate-180",
            "mx-mini mt-pico w-[12px] transform transform-gpu",
          )}
        />
      </div>
      <AccordionAnimation active={show}>
        <FormRadio
          className="gap-mini p-midi"
          name="sort"
          orientation="col"
          value={sortOption?.handle || ""}
          options={sortOptions.map((option) => ({
            value: option.handle,
            label: option.name,
          }))}
          onChange={(value) => {
            setSortOption(value);
            scrollTo(0, null, 1000);
          }}
        />
      </AccordionAnimation>
    </div>
  );
};
